import { gql } from 'graphql-request';

import withFragments from 'utils/graphql';

import Hero from 'fragments/Hero';

export default withFragments(
  gql`
    query($id: Int, $contentType: String!, $token: String!) {
      page(id: $id, contentType: $contentType, token: $token) {
        id
        url
        title
        slug
        seoTitle
        seoDescription
        ... on AudienceSplitPage {
          linkBlockTitle
          linkBlockText
          linkBlockLinks {
            ... on PageLinkBlock {
              id
              page {
                title
                url
                id
              }
              linkText
            }
          }
          heroImage {
            ...Hero
          }
        }
      }
    }
  `,
  { Hero },
);
